import { LabelPlaceholders, VOLabel, VOLabelKey, VOLabelList } from "./DataStructure.js";

export interface LabelsOptions {
    labels: VOLabelList[];
}

export class Labels {
    private _uiLabels: { [key: string]: string } = {};
    private _showLabelKeys: boolean = Cookies.get("phil-show-label-keys") === "true";
    private _showUiLabelKeyFallback = location.host === "127.0.0.1";

    constructor(options: LabelsOptions) {

        for (var l of options.labels) {
            for (var li of l.labels) {
                this._uiLabels[l.key + "." + li.key] = li.label;
            }
        }

        // console.log(this.getTypeScript());

        if (window.tools?.debug) {
            window.tools?.debug.add({
                tooltip: "Show label keys",
                uid: "show-label-keys",
                icon: "fal fa-key",
                cookie: "phil-show-label-keys"
            });

            if (window.tools?.debug?.active("show-label-keys")) {

                document.addEventListener("click", async (e) => {
                    if (e.ctrlKey) {
                        e.stopImmediatePropagation();
                        e.preventDefault();

                        var t: HTMLElement = e.target as HTMLElement;
                        while (t) {
                            var c = t.textContent;
                            if (c
                                && c.trim()
                                && this._uiLabels.hasOwnProperty(c.trim())
                            ) {

                                var text =  c.trim().split(".").slice(1).join(".");
                                await navigator.clipboard.writeText(text).then(function () {
                                    console.log("COPY LABEL KEY TO CLIPBOARD",);
                                });
                                e5.Toast.showText("Copied to clipboard:<br>" + text, 2, "label-key-copied");
                                break;
                            }

                            t = t.parentElement as HTMLElement;
                        }


                    }
                },
                    {
                        passive: false,
                        capture: true
                    });
            }
        }
    }

    private getTypeScript(): string {
        var str = "";

        for (var k in this._uiLabels) {
            str += `| "${k}"\n`;
        }

        return str;
    }

    //Make the trans function globally available.
    public trans(keys: VOLabel, encode: "html" | "attr" | "text" = "html"): string {

        var key = this.getKey(keys);
        var params = this.getParams(keys);

        var lab = this._uiLabels[key];

        if (lab && params) {
            for (var k in params) {
                lab = e5.Text.replaceAll(lab, "${" + k + "}", String(params[k]));
            }
        }

        if (this._showLabelKeys) {
            lab = key;
        }

        if (typeof lab === "string") {
            if (encode === "html")
                return e5.Text.escapeHtml(lab);
            else if (encode === "attr")
                return e5.Text.escapeHtml(lab);
            return lab;
        } else if (this._showUiLabelKeyFallback) {
            console.warn("Missing ui_label. Key: ", key);
            return key;
        }

        return "";
    }

    public all(): { value: string; key: VOLabelKey }[] {
        var labels: { value: string; key: VOLabelKey }[] = [];
        for (var a in this._uiLabels) {
            labels.push({ value: this._uiLabels[a], key: a as VOLabelKey });
        }
        labels.sort((a, b) => {
            return a.key.localeCompare(b.key);
        })
        return labels;
    }

    public html(key: VOLabel): string {
        return this.trans(key, "html");
    }

    public attr(key: VOLabel): string {
        return this.trans(key, "attr");
    }

    public text(key: VOLabel): string {
        return this.trans(key, "text");
    }

    public raw(key: VOLabel): string {
        return this._uiLabels[this.getKey(key)];
    }

    public set(key: VOLabel, value: string): void {
        this._uiLabels[this.getKey(key)] = value;
    }

    public getKey(key: VOLabel): VOLabelKey {
        if (!key) {
            return null;
        }

        if (typeof key === "string") {
            return key;
        }
        return key.key;
    }

    public has(key:VOLabel):key is VOLabel{
        return this.getKey(key) in this._uiLabels;
    }

    private getParams(key: VOLabel): LabelPlaceholders {
        if (!key) {
            return null;
        }
        if (typeof key === "string") {
            return null;
        }
        return key.params;
    }
}